import packageInfo from '../../package.json';

export const environment = {
  production: false,
  testing: true,
  env: 'testing',
  apiUrl: 'https://devmesapi.performolabs.in',
  appVersion: packageInfo.version,
  wsUrl: 'wss://devmesapi.performolabs.in',
  cdnUrl: 'https://mes-bucket.sgp1.digitaloceanspaces.com',
};
